import { z } from 'zod'

const phoneNumberSchema = z.object({
  CountryCode: z.string(),
  Prefix: z.string(),
  Number: z.string(),
})

export const drugScreenSchema = z.object({
  Status: z.string(),
  CompleteDate: z.string().nullish(),
  ExpireDate: z.string().nullish(),
})

const identityVerificationSchema = z.object({
  Status: z.string().optional(),
  RequestDateTime: z.string().nullish(),
})

/**
 * A single patient row as rendered on the Patient charts list. The schema is
 * the runtime validator for persisted "recently viewed" entries; the Redux
 * `charts.patientsList` rows (untyped at runtime) carry the same fields.
 */
export const patientChartListItemSchema = z.object({
  PatientId: z.string(),
  FirstName: z.string(),
  LastName: z.string(),
  ImageUrl: z.string().nullish(),
  Gender: z.string(),
  BirthDate: z.string(),
  MedicalRecordNumber: z.string(),
  StateCode: z.string(),
  PhoneNumber: phoneNumberSchema,
  Email: z.string(),
  LastSeenDateTime: z.string().nullish(),
  RestrictionStatus: z.string().optional(),
  IsMergedMainAccount: z.boolean().optional(),
  DrugScreen: drugScreenSchema.nullish(),
  IdentityVerification: identityVerificationSchema.nullish(),
})

export type PatientChartListItem = z.infer<typeof patientChartListItemSchema>
export type DrugScreenInfo = z.infer<typeof drugScreenSchema>
